module.exports = ".align-buttons {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-maintenance-asing-finish/master-maintenance-asing-finish.component.scss
// module id = ./src/app/master/master-maintenance-asing-finish/master-maintenance-asing-finish.component.scss
// module chunks = main